module.exports = __webpack_public_path__ + "media/images/icon_other-dd2cc5aecbfbccd7674bdd046d627409.svg";